import { jsx } from "react/jsx-runtime";
import stitches from "../theme.config.es.js";
const picker = stitches.css({
  stroke: "$black100",
  input: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    ":focus": { outlineStyle: "auto" }
  },
  "&& input": { paddingRight: "2em" },
  svg: { transition: "transform 0.3s" },
  variants: {
    disabled: {
      true: { stroke: "$textDisabled" }
    }
  }
});
const TextInputWrapper = (props) => /* @__PURE__ */ jsx("div", { ...picker(props).props });
export {
  TextInputWrapper
};
//# sourceMappingURL=Picker.styles.es.js.map
